import { Messages } from '~src/codegen/Localize';

import { PoolAssignmentOption } from '../types/PoolAssignmentOption';
import { PoolID, SystemDefinedPoolID } from '../types/PoolID';
import { UserDefinedPoolModel } from '../types/PoolModel';

export function getPoolNameFromPoolID(pools: Record<string, UserDefinedPoolModel>, poolID: PoolID | null): string | undefined {
  if (poolID === null) {
    return undefined;
  }

  return pools[poolID]?.displayName;
}

export function createPoolOptionsFromPools(pools: Record<string, UserDefinedPoolModel>): PoolAssignmentOption[] {
  const items: PoolAssignmentOption[] = [];
  for (const pool of Object.values(pools)) {
    items.push({
      poolID: pool.poolId,
      poolDisplayName: pool.displayName
    });
  }

  return items;
}

export function createPoolOptionsFromSystemDefinedPools(): PoolAssignmentOption[] {
  const items: PoolAssignmentOption[] = [];
  items.push({
    poolID: SystemDefinedPoolID.Default as PoolID,
    poolDisplayName: Messages.siteRemoteAgentPoolNameDefault()
  });
  items.push({
    poolID: SystemDefinedPoolID.Unassigned as PoolID,
    poolDisplayName: Messages.siteRemoteAgentPoolNameUnassigned()
  });
  return items;
}
